import OrderedList from '@tiptap/extension-ordered-list';

export default OrderedList.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            style: {
                default: null,
            },
            class: {
                default: null,
            },
            id: {
                default: null,
            },
        };
    },
});
